const Dropdown = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.79 9.60058C17.07 9.91162 17.07 10.4093 16.79 10.7203L12.4977 15.1993C12.1866 15.4793 11.689 15.4793 11.409 15.1993L7.20995 10.7203C6.93002 10.4093 6.93002 9.91162 7.20995 9.60058C7.521 9.32064 8.01866 9.32064 8.3297 9.60058L12 13.5819L15.6703 9.60058C15.9813 9.32064 16.479 9.32064 16.79 9.60058Z"
        fill="#1A1919"
      />
    </svg>
  );
};

export default Dropdown;
